module.exports = __webpack_public_path__ + "img/рз_21.f1a83198.png";